import { FAILURE, IDLE, REQUEST, SUCCESS } from 'src/redux/constants';
import { ADD_CREATE_SURVEYS } from './constants';
import { ThunkAction } from 'redux-thunk';
import { State } from 'src/redux/reducer';
import { AddCreateSurveysDataActionTypes } from './types';
import api from 'src/utils/api';
import { push } from 'connected-react-router';
import { LocalStorageKeysEnum } from 'src/utils/enum';
import { setTitleNew } from '../titleCreateTest/actions';
import { CreateTestNewTitle } from 'src/config/config';

export const loadAddCreateSurveys =
  (): ThunkAction<
    Promise<void>,
    State,
    null,
    AddCreateSurveysDataActionTypes
  > =>
  async (dispatch: any) => {
    dispatch({ type: ADD_CREATE_SURVEYS + REQUEST });
    try {
      const payload = await api.loadCreateSurvey();
      dispatch({ type: ADD_CREATE_SURVEYS + SUCCESS, payload });
      dispatch(setTitleNew(CreateTestNewTitle));
      dispatch(push(`/createTest/${payload.id}`));
      localStorage.setItem(LocalStorageKeysEnum.ID_SERVEY, payload.id);
    } catch (error) {
      dispatch({ type: ADD_CREATE_SURVEYS + FAILURE, error });
    }
  };

export const createSurveysIdle = () => ({ type: ADD_CREATE_SURVEYS + IDLE });
